export const getLocalDateKey = (date: Date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};

export const dateFromLocalKey = (dateKey: string) => {
    const [year, month, day] = dateKey.split('-').map(Number);
    return new Date(year, month - 1, day);
};

export const formatHour = (hour: number) => {
    return hour.toString().padStart(2, '0') + ':00';
};

export const formatTaskTimeRange = (startDate: Date, durationMinutes = 60) => {
    const endDate = new Date(startDate.getTime() + durationMinutes * 60000);
    const start = `${startDate.getHours().toString().padStart(2, '0')}:${startDate.getMinutes().toString().padStart(2, '0')}`;
    const end = `${endDate.getHours().toString().padStart(2, '0')}:${endDate.getMinutes().toString().padStart(2, '0')}`;

    return { start, end, endDate };
};
